import {
  FilledInput,
  FormControl,
  FormHelperText,
  Input,
  InputLabel,
  OutlinedInput,
  TextField,
} from '@material-ui/core';
import { InputProps } from '@material-ui/core/Input';
import { OutlinedInputProps } from '@material-ui/core/OutlinedInput';
import * as React from 'react';
import { ValidatorComponent } from 'react-form-validator-core';

export interface InputValidatorProps {
  requiredError?: string;
  // Array of error messages. Order of messages should be the same as validators prop.
  errorMessages: string[];
  // Array of validators. See list of default validators above.
  validators: string[];
  // Classname of the container class.
  containerClass?: string;
  // Helper text, shown below the input element.
  helperText?: string | JSX.Element;
  // The label of the element.
  label: string | JSX.Element;
  // It triggers after each validation. It will return true or false
  validatorListener?: any;
  // Name of input
  name: string;
  // Allow to use required validator in any validation trigger, not only form submit.
  withRequiredValidator?: boolean;

  variant?: 'standard' | 'filled' | 'outlined';
}

interface State {
  isValid: boolean;
}

const inputVariantComponent = {
  standard: Input,
  filled: FilledInput,
  outlined: OutlinedInput,
};

// tslint:disable:max-classes-per-file
export default class InputValidator extends ValidatorComponent<InputValidatorProps & InputProps, State> {
  state: State = {
    isValid: true,
  };

  render() {
    const {
      errorMessages,
      validators,
      containerClass,
      requiredError,
      helperText,
      label,
      validatorListener,
      onKeyPress,
      variant,
      ...rest
    } = this.props;
    const { isValid } = this.state;

    const InputVariantComponent = inputVariantComponent[variant || 'standard'];

    const extraProps = {} as OutlinedInputProps;
    if (variant === 'outlined') {
      extraProps.labelWidth = 1;
    }

    const id = rest.id || rest.name || `${Date.now()}-${Math.floor(Math.random() * 1000)}`.slice(10);

    return (
      <FormControl fullWidth className={containerClass}>
        <InputLabel htmlFor={id}>{label}</InputLabel>
        <InputVariantComponent id={id} {...rest} {...extraProps} error={!isValid} />
        <FormHelperText error={!isValid}>{(!isValid && this.getErrorMessage()) || helperText}</FormHelperText>
      </FormControl>
    );
  }
}

export class SelectValidator extends ValidatorComponent<any, any> {
  render() {
    /* eslint-disable no-unused-vars */
    const {
      error,
      errorMessages,
      validators,
      requiredError,
      helperText,
      validatorListener,
      withRequiredValidator,
      containerClass,
      ...rest
    } = this.props;
    const { isValid } = this.state;
    return (
      <FormControl fullWidth className={containerClass}>
        <TextField
          {...rest}
          select
          error={!isValid || error}
          helperText={(!isValid && this.getErrorMessage()) || helperText}
        />
      </FormControl>
    );
  }
}

/**
 * Wrap form components in a validator component, that will display the error text, and set a
 * passed in `validClass`/`invalidClass`.
 */
export class WrapValidator extends ValidatorComponent<any, any> {
  render() {
    /* eslint-disable no-unused-vars */
    const {
      error,
      errorMessages,
      validators,
      requiredError,
      helperText,
      validatorListener,
      withRequiredValidator,
      containerClass,
      children,
      invalidClass,
      validClass,
      ...rest
    } = this.props;
    const { isValid } = this.state;
    const formContainerClass = `${containerClass} ${
      isValid ? (validClass ? validClass : '') : invalidClass ? invalidClass : ''
    }`;
    return (
      <FormControl fullWidth className={formContainerClass}>
        {children}
        <FormHelperText error={!isValid}>{(!isValid && this.getErrorMessage()) || helperText}</FormHelperText>
      </FormControl>
    );
  }
}
